import { getInfoAboutAdmin, getUsersForAdmin, updateUserStatus, deleteUser, updateUserRole } from "./asyncThunk";
import { refresh, logIn } from "../auth/asyncThunk";

export const getInfoAboutAdminBuilder = (builder) => {
  builder.addCase(getInfoAboutAdmin.pending, (state) => {
    state.getInfoAboutAdminPending = true;
  });
  builder.addCase(getInfoAboutAdmin.fulfilled, (state, { payload }) => {
    state.admin = payload.admin;
    state.getInfoAboutAdminPending = false;
  });
  builder.addCase(getInfoAboutAdmin.rejected, (state) => {
    state.admin = undefined;
    state.getInfoAboutAdminPending = false;
  });
};

export const getUsersForAdminBuilder = (builder) => {
  builder.addCase(getUsersForAdmin.pending, (state) => {
    state.users.loading = true;
  });
  builder.addCase(getUsersForAdmin.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.users.data = data.users;
    state.users.perPage = data.limit;
    state.users.page = data.page;
    state.users.total = data.total;
    state.users.totalPages = data.totalPages;
    state.users.maxReached = false;
    state.users.loading = false;
  });
  builder.addCase(getUsersForAdmin.rejected, (state, action) => {
    state.users.error = action.error.message;
    state.users.loading = false;
  });
};

export const logInBuilder = (builder) => {
  builder.addCase(logIn.fulfilled, (state, { payload }) => {
    const { admin } = payload.data;
    state.admin = admin;
  });
};

export const refreshBuilder = (builder) => {
  builder.addCase(refresh.rejected, (state) => {
    state.admin = undefined;
  });
};

export const updateUserStatusBuilder = (builder) => {
  builder.addCase(updateUserStatus.pending, (state, { meta }) => {
    const userId = meta.arg.userId;
    state.userActions.updating[userId] = true;
  });
  builder.addCase(updateUserStatus.fulfilled, (state, { payload, meta }) => {
    const userId = meta.arg.userId;
    const updatedUser = payload.data.user;
    state.users.data = state.users.data.map(user =>
      user.id === updatedUser.id ? updatedUser : user
    );
    state.userActions.updating[userId] = false;
  });
  builder.addCase(updateUserStatus.rejected, (state, { meta }) => {
    const userId = meta.arg.userId;
    state.userActions.updating[userId] = false;
  });
};

export const deleteUserBuilder = (builder) => {
  builder.addCase(deleteUser.pending, (state, { meta }) => {
    const userId = meta.arg;
    state.userActions.deleting[userId] = true;
  });
  builder.addCase(deleteUser.fulfilled, (state, { payload, meta }) => {
    const userId = meta.arg;
    const deletedUserId = payload.data.userId;
    state.users.data = state.users.data.filter(user => user.id !== deletedUserId);
    state.users.total = state.users.total - 1;
    state.userActions.deleting[userId] = false;
  });
  builder.addCase(deleteUser.rejected, (state, { meta }) => {
    const userId = meta.arg;
    state.userActions.deleting[userId] = false;
  });
};

export const updateUserRoleBuilder = (builder) => {
  builder.addCase(updateUserRole.pending, (state, { meta }) => {
    const userId = meta.arg.userId;
    state.userActions.updating[userId] = true;
  });
  builder.addCase(updateUserRole.fulfilled, (state, { payload, meta }) => {
    const userId = meta.arg.userId;
    const updatedUser = payload.data.user;
    state.users.data = state.users.data.map(user =>
      user.id === updatedUser.id ? updatedUser : user
    );
    state.userActions.updating[userId] = false;
  });
  builder.addCase(updateUserRole.rejected, (state, { meta }) => {
    const userId = meta.arg.userId;
    state.userActions.updating[userId] = false;
  });
};
